import React, { useState } from "react";

const AddGuarantors = ({
  isAddGuarantorsOpen,
  closeAddGuarantors,
  handleSubmitGuarantors,
  refreshGuarantors,
  handleRemoveGuarantor,
  manualLoanGuarantors = [],
  guarantorRequestId,
  handleSubmitLoanApplication,
  handleGuarantorBack,
}) => {
  const [guarantorName, setGuarantorName] = useState("");
  const [guarantorPhone, setGuarantorPhone] = useState("");

  const addGuarantor = async () => {
    if (!guarantorName || !guarantorPhone) return;
    const newGuarantor = { name: guarantorName, phone: guarantorPhone };

    try {
      await handleSubmitGuarantors(newGuarantor);
      setGuarantorName("");
      setGuarantorPhone("");
      if (refreshGuarantors) await refreshGuarantors();
    } catch (error) {
      console.error("Failed to add guarantor:", error);
    }
  };

  if (!isAddGuarantorsOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-10 px-4">
      <div className="relative bg-white shadow-md rounded-sm w-[740px] p-10 flex flex-col h-[85vh]">
        <button
          onClick={closeAddGuarantors}
          className="absolute top-4 right-5 text-gray-800 hover:text-black text-lg font-bold"
        >
          &times;
        </button>

        <div className="mb-[40px]">
          <h2 className="text-xl font-semibold text-gray-900 mb-1">
            Add Guarantors
          </h2>
          <p className="text-gray-600 text-sm">Add Guarantors from below</p>
        </div>

        <div className="flex flex-col gap-4 mb-[40px]">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Guarantor Name
              </label>
              <input
                type="text"
                placeholder="Enter Guarantor Name"
                value={guarantorName}
                onChange={(e) => setGuarantorName(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Guarantor Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter Guarantor Phone Number"
                value={guarantorPhone}
                onChange={(e) => setGuarantorPhone(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
            </div>
          </div>

          <button
            onClick={addGuarantor}
            className="bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2 px-6 rounded-sm text-sm w-fit mx-auto transition-colors duration-150"
          >
            Add Guarantor
          </button>
        </div>

        <div className="flex flex-col flex-grow mt-[10px]">
          <div className="bg-blue-50 p-4 rounded-md flex flex-col gap-3 max-h-[250px] overflow-y-auto">
            <h3 className="text-base font-semibold text-gray-900 mb-2">
              Added Guarantors
            </h3>
            {manualLoanGuarantors.length > 0 ? (
              manualLoanGuarantors.map((guarantor, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center text-sm"
                >
                  <div className="flex flex-col">
                    <span className="text-gray-900 font-medium">
                      {guarantor.guarantorName}
                    </span>
                    <span className="text-gray-700 text-xs">
                      {guarantor.guarantorPhoneNumber}
                    </span>
                  </div>
                  <button
                    onClick={() => handleRemoveGuarantor(guarantor.id)}
                    className="text-red-500 hover:text-red-700 text-sm font-medium"
                  >
                    Remove
                  </button>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-sm italic">
                Added guarantors will appear here
              </p>
            )}
          </div>
        </div>

        <div className="flex justify-between border-t border-gray-200 pt-3 mt-[16px]">
          <div className="flex space-x-3">
            <button
              onClick={closeAddGuarantors}
              className="border border-[#074073] text-[#074073] hover:bg-[#f5f9ff] font-medium py-2 px-5 rounded-sm text-sm transition-colors duration-150"
            >
              Cancel Application
            </button>
          </div>

          <button
            onClick={handleSubmitLoanApplication}
            className="bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2 px-6 rounded-sm text-sm transition-colors duration-150"
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGuarantors;
